import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';
import { WhiteLogoComponent } from './white-logo/white-logo.component';

import { AgentCardComponent } from './agent-card/agent-card.component';
import { CardFrameComponent } from './card-frame/card-frame.component';
import { AuthGuard } from '@uoa/auth';
import { StatusSummaryComponent } from './status-summary/status-summary.component';
import { StatsBoardComponent } from '../call-centres/stats-board/stats-board.component';
import { AgentBoardComponent } from '../call-centres/agent-board/agent-board.component';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { WALLBOARD_ROUTE_PATHS } from 'src/app/core/route-paths';

@NgModule({
  imports: [
    // BrowserModule,
    HttpClientModule,
    IonicModule,
    RouterModule.forChild([
      // Staff Service Centre
      {
        path: WALLBOARD_ROUTE_PATHS.staffStats,
        canActivate: [AuthGuard],
        component: StatsBoardComponent,
        data: {
          agents: environment.wallboards.staff.agents,
          stats: environment.wallboards.staff.stats,
        },
      },
      {
        path: WALLBOARD_ROUTE_PATHS.staffTvStats,
        component: StatsBoardComponent,
        data: {
          agents: environment.wallboards.staff.agents,
          stats: environment.wallboards.staff.stats,
        },
      },
      // Agents
      {
        path: WALLBOARD_ROUTE_PATHS.agentStats,
        canActivate: [AuthGuard],
        component: AgentBoardComponent,
        data: {
          agents: environment.wallboards.staff.agents,
          stats: environment.wallboards.staff.stats,
        },
      },
      {
        path: WALLBOARD_ROUTE_PATHS.agentTvStats,
        component: AgentBoardComponent,
        data: {
          agents: environment.wallboards.staff.agents,
          stats: environment.wallboards.staff.stats,
        },
      },
    ]),
    CommonModule,
    // StatsBoardComponent,
    // AgentBoardComponent,
    WhiteLogoComponent,
    AgentCardComponent,
    CardFrameComponent,
    StatusSummaryComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [StatusSummaryComponent, CardFrameComponent, AgentCardComponent],
})
export class WallboardsModule {}
